enum UserSieveField {
    Id = 'id',
    IsDisabled = 'isDisabled',
    Firstname = 'firstName',
    Lastname = 'lastName',
    Username = 'username',
    Email = 'email',
    User = 'user', //filter
    Role = 'user_role', //filter
    Brand = 'user_brand', //filter
    Agency = 'user_agency' //filter & sort
}
enum UserFilter {
    Brand = UserSieveField.Brand,
    Role = UserSieveField.Role,
    IsDisabled = UserSieveField.IsDisabled,
    Id = UserSieveField.Id,
    User = UserSieveField.User
}
enum UserSort {
    Id = UserSieveField.Id,
    Firstname = UserSieveField.Firstname,
    Lastname = UserSieveField.Lastname,
    Username = UserSieveField.Username,
    Agency = UserSieveField.Agency,
    Email = UserSieveField.Email
}

enum CatalogSieveField {
    Id = 'id',
    Denominazione = 'catalogName',
    ValidoDa = 'fromDate',
    ValidoFino = 'toDate',
    AttivabileDa = 'activationFromDate',
    AttivabileFino = 'activationToDate',
    EnergyOrGas = 'energyOrGas',
    Catalog = 'catalog', //filter
    HasCte = 'catalog_hasCte', //filter
    Brand = 'catalog_brand', //filter
    IsGenerali = 'catalog_isGenerali', // filter
}
enum CatalogFilter {
    Catalog = CatalogSieveField.Catalog,
    EnergyOrGas = CatalogSieveField.EnergyOrGas,
    HasCte = CatalogSieveField.HasCte,
    Brand = CatalogSieveField.Brand,
    IsGenerali = CatalogSieveField.IsGenerali
}
enum CatalogSort {
    Id = CatalogSieveField.Id,
    Denominazione = CatalogSieveField.Denominazione,
    ValidoDa = CatalogSieveField.ValidoDa,
    ValidoFino = CatalogSieveField.ValidoFino,
    AttivabileDa = CatalogSieveField.AttivabileDa,
    AttivabileFino = CatalogSieveField.AttivabileFino
}

enum ContractSieveField {
    Id = 'id',
    Brand = 'brand',
    DataCreazione = 'createdDateTime',
    Stato = 'phase',
    Contratto = 'typeContract',
    Operazione = 'typeRequestSupply',
    Citta = 'city',
    Contract = 'contract', //filter
    Cliente = 'contract_customer', //sort
    NPod = 'contract_npod', //sort
    NPdr = 'contract_npdr', //sort
    Agenzia = 'contract_agency', //sort
    Agente = 'contract_owner', //filter & sort
    ContractPhaseOR = 'contract_phaseContractOr' //filter
}
enum ContractFilter {
    ContractPhaseOR = ContractSieveField.ContractPhaseOR,
    Contract = ContractSieveField.Contract
}
enum ContractSort {
    Id = ContractSieveField.Id,
    Brand = ContractSieveField.Brand,
    DataCreazione = ContractSieveField.DataCreazione,
    Cliente = ContractSieveField.Cliente,
    Stato = ContractSieveField.Stato,
    Agenzia = ContractSieveField.Agenzia,
    Agente = ContractSieveField.Agente,
    Contratto = ContractSieveField.Contratto,
    Operazione = ContractSieveField.Operazione,
    Citta = ContractSieveField.Citta,
    NPod = ContractSieveField.NPod,
    NPdr = ContractSieveField.NPdr
}

enum CustomerSieveField {
    Id = 'id',
    Email = 'email',
    TipoCliente = 'anagraphicType',
    Denominazione = 'firstName',
    CfIva = 'fiscalCode',
    TelFisso = 'phoneNumber',
    TelMobile = 'mobilePhoneNumber',
    AnagraphicType = 'anagraphicType',
    Customer = 'customer',
    AnagraphicTypeOR = 'customer_anagraphicTypeOR'
}

enum DistributorSievField {
    Name = 'name',
    Type = 'type'
}
enum SupplierSieveField {
    Name = 'name'
}

enum CustomerFilter {
    Customer = CustomerSieveField.Customer,
    AnagraphicTypeOR = CustomerSieveField.AnagraphicTypeOR,
    AnagraphicType = CustomerSieveField.AnagraphicType
}

enum DistributorFilter {
    Name = DistributorSievField.Name,
    Type = DistributorSievField.Type,
}
enum SupplierFilter {
    Name = SupplierSieveField.Name
}

enum CustomerSort {
    Id = CustomerSieveField.Id,
    Email = CustomerSieveField.Email,
    TipoCliente = CustomerSieveField.TipoCliente,
    Denominazione = CustomerSieveField.Denominazione,
    CfIva = CustomerSieveField.CfIva,
    TelFisso = CustomerSieveField.TelFisso,
    TelMobile = CustomerSieveField.TelMobile
}

enum StorageFileSieveField {
    StorageFile = 'file',
    Id = 'id',
    NomeFile = 'filename',
    DimensioneFile = 'sizeInBytes',
    DataCaricamento = 'uploadDateTime'
}
enum StorageFileFilter {
    StorageFile = StorageFileSieveField.StorageFile
}
enum StorageFileSort {
    Id = StorageFileSieveField.Id,
    NomeFile = StorageFileSieveField.NomeFile,
    DimensioneFile = StorageFileSieveField.DimensioneFile,
    DataCaricamento = StorageFileSieveField.DataCaricamento
}

enum ViewSieveField {
    Role = 'roleId'
}
enum ViewFilter {
    Role = ViewSieveField.Role
}
enum ViewSort {
    Role = ViewSieveField.Role
}

export class SieveSort {
    static readonly User = UserSort;
    static readonly Catalog = CatalogSort;
    static readonly Contract = ContractSort;
    static readonly Customer = CustomerSort;
    static readonly StorageFile = StorageFileSort;
    static readonly View = ViewSort;
}

export class SieveFilter {
    static readonly Contract = ContractFilter;
    static readonly StorageFile = StorageFileFilter;
    static readonly User = UserFilter;
    static readonly Catalog = CatalogFilter;
    static readonly View = ViewFilter;
    static readonly Customer = CustomerFilter;
    static readonly Distributor = DistributorFilter;
    static readonly Supplier = SupplierFilter;
}



// WEBPACK FOOTER //
// ./src/app/helpers/sieve/sieve-filters-and-sorts.ts